import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/ui/Modal';

/**
 * «BETA» I TOPPEN (Atle 02.11): Tvitvi er i testfase, også på app.tvitvi.com. Et trykk forteller at
 * noe kan være feil eller mangle, og hvem man skriver til. Blå på begge temaer, uavhengig av
 * aksentfargen brukeren har valgt, fordi det er merket og ikke en handling.
 */
export function BetaBadge(): ReactNode {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const email = t('beta.contactEmail');
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="rounded-full bg-[#2563eb] px-2 py-0.5 text-[11px] font-semibold tracking-wide text-white uppercase ring-focus hover:bg-[#1d4ed8]"
        aria-haspopup="dialog"
        data-testid="beta-badge"
      >
        {t('beta.label')}
      </button>
      <Modal
        open={open}
        onOpenChange={setOpen}
        title={t('beta.title')}
        size="sm"
        cancel={{ label: t('beta.close'), 'data-testid': 'beta-close' }}
      >
        <div className="flex flex-col gap-3 text-sm text-default" data-testid="beta-message">
          <p>{t('beta.underDevelopment')}</p>
          <p>{t('beta.feedback')}</p>
          <p>
            <span className="font-medium">{t('beta.contactName')}</span>
            {' · '}
            <a href={`mailto:${email}`} className="text-accent-text underline ring-focus">
              {email}
            </a>
          </p>
        </div>
      </Modal>
    </>
  );
}
